import(/* webpackMode: "eager" */ "/opt/build/repo/app/downloads/page.tsx");
